import i18n from 'i18next';

async function fetchLanguage(lang){
  return await fetch(`${window.location.origin}/locales/${lang}.json`).then(async response=>{
    return response.json()
  })
}

const resources = {
  it: {translation: await fetchLanguage('it')},
};

i18n.init({
    resources,
    fallbackLng: 'it',
    debug: true,
    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
    }
  });


export default i18n;
